import { TimePicker as BaseTimePicker } from 'baseui/timepicker';

type ITimepickerProps = any;

export const Timepicker = (props: ITimepickerProps) => {
  return <BaseTimePicker {...props} />;
};
